export const COMPLETED = "completed";
export const NOT_ATTEMPTED = "notAttempted";
export const INCOMPLETE = "incomplete";
export const PASSED = "passed";
export const FAILED = "failed";
export const UNKNOWN = "unknown";
export const UNLOCKED = "unlocked";
